export default "__VITE_ASSET__pi1Oem6I__"